import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';
import { configurations } from '../../../configurations';
import { endpoints } from '../../../endpoints/endpoints';

@Injectable()
export class ConfigService {
    private _domainConfigData;
    config: Object = {
        'routes': {
            /** -------------------------SAHARA---------------------------- */
            // ToDo: remove routes from contract
            sahara: {
                storeFileDetails: '/api/file/store-details',
                signature: '/api/file/signature',
                complete: '/api/file/complete'
            },
            /** -------------------------AMBER---------------------------- */

            //  Users (toDo: remove route from contract/components/partners)
            listUsers: '/users'
        }
    };

    constructor() {
        this.config = Object.assign(this.config, environment.config);
        this.config = Object.assign(this.config, configurations);
        this.config['endpoints'] = endpoints;
        this.config['envName'] = environment.name;
    }

    get(key: any) {
        return this.config[key];
    }

    getSphinxUrl(system: string, bucket: string, file: string): string {
        let result = this.get('server').sphinx +
            this.get('endpoints').sphinx.download.api +
            '/' + system + '/' + bucket + '/' + file;
        return result;
    }

    getSphinxUrlUnsecured(system: string, bucket: string, file: string): string {
        let result = this.get('server').sphinx +
            this.get('endpoints').sphinx.proxy.api +
            '/' + system + '/jwt/' + bucket + '/' + file;
        return result;
    }

    getDomainConfigData() {
        return this._domainConfigData;
    }
    setDomainConfigData(data) {
        this._domainConfigData = data
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/config.service.ts